export const RECORD_STATUS = {
  IDLE : "idle",
  RECORDING : "recording",
  PAUSED : "paused",
}
